export const API = {  
    UPDATE_REP_NOTES: {
      path: '/v1/Schedule/update-rep-notes',
      method: 'POST',
    },  
};